
///<reference path="../../model/AppState.ts"/>

namespace khi.bk117.view.parts
{
  import EventDispatcher = com.enirva.event.EventDispatcher;
	import Sprite = com.enirva.display.Sprite;
	import AppState = khi.bk117.model.AppState;

  export class HorizontalScrollerBase extends EventDispatcher
  {
		protected scrollContainer:Sprite;

		protected isLoop:boolean;

		public currentIndex:number;

		public maxIndex:number = 0;

		public maskArea:JQuery;

		public isFirstShow:boolean;


    constructor()
    {
			super();

			this.isLoop = false;
			this.isFirstShow = false;
		}


		public get isLimitPositionLeft():boolean
		{
			let flag:boolean = false;

			if (this.isLoop)
			{
				return false;
			}
			else
			{
				return (this.currentIndex == 0);
			}
		}


		public get isLimitPositionRight():boolean
		{
			let flag:boolean = false;

			if (this.isLoop)
			{
				return false;
			}
			else
			{
				return (this.currentIndex == (this.maxIndex - 1));
			}
		}


		public showFaderObject():void
		{
			
		}
  }
}

